import { Flags, FlagsControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */

interface Params {
  flags: Flags;
  xTENANTID?: string;
}

export const useAddFlag = () =>
  useMutationWithLoading(async (params: Params) =>
    new FlagsControllerApi(getConfigObject()).createFlags(
      params.flags,
      params.xTENANTID
    )
  );
